(() => {
  // Haelt Tracking-Aufrufe der eingebundenen Apps zurueck, bis die passende Einwilligung vorliegt, und fuehrt sie danach aus.
  // Analyse: Google Analytics, Microsoft Clarity, Juicy Profit. Marketing: impact.com, GoAffPro, UpPromote.
  const RULES = [
    { purpose: 'analytics', test: /clarity\.ms|googletagmanager\.com|google-analytics\.com|analytics\.google\.com|analytics-integration\.onrender\.com/ },
    { purpose: 'marketing', test: /saasler-impact\.herokuapp\.com|impact\.com|impactradius|goaffpro|uppromote/ }
  ];
  const allowed = { analytics: false, marketing: false };
  const queue = [];

  function readCookie() {
    const match = document.cookie.match(/(?:^|; )_tracking_consent=([^;]*)/);
    if (!match) return null;
    try {
      const data = JSON.parse(decodeURIComponent(match[1]));
      const purposes = (data.con && data.con.CMP) || data.purposes || {};
      const yes = (value) => value === '1' || value === true || value === 'yes';
      return { analytics: yes(purposes.a), marketing: yes(purposes.m) };
    } catch (error) {
      return null;
    }
  }

  function refresh() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.currentVisitorConsent === 'function') {
      const consent = privacy.currentVisitorConsent();
      allowed.analytics = consent.analytics === 'yes';
      allowed.marketing = consent.marketing === 'yes';
      return;
    }
    const consent = readCookie();
    if (consent) Object.assign(allowed, consent);
  }

  function purposeOf(url) {
    const rule = RULES.find((entry) => entry.test.test(String(url || '')));
    return rule ? rule.purpose : '';
  }
  const isBlocked = (url) => {
    const purpose = purposeOf(url);
    return Boolean(purpose) && !allowed[purpose];
  };
  const hold = (url, run) => queue.push({ purpose: purposeOf(url), run });

  function flush() {
    refresh();
    for (let index = 0; index < queue.length;) {
      if (!allowed[queue[index].purpose]) { index += 1; continue; }
      queue.splice(index, 1)[0].run();
    }
  }

  function holdScripts(original) {
    return function (node, ...rest) {
      if (node && node.tagName === 'SCRIPT' && node.src && isBlocked(node.src)) {
        hold(node.src, () => original.call(this, node, ...rest));
        return node;
      }
      return original.call(this, node, ...rest);
    };
  }
  Node.prototype.appendChild = holdScripts(Node.prototype.appendChild);
  Node.prototype.insertBefore = holdScripts(Node.prototype.insertBefore);

  const nativeFetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : input && input.url;
    if (!isBlocked(url)) return nativeFetch.apply(this, arguments);
    const args = arguments;
    return new Promise((resolve, reject) => {
      hold(url, () => nativeFetch.apply(this, args).then(resolve, reject));
    });
  };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.eaUrl = url;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (!isBlocked(this.eaUrl)) return nativeSend.apply(this, arguments);
    const args = arguments;
    hold(this.eaUrl, () => nativeSend.apply(this, args));
    return undefined;
  };

  const nativeBeacon = navigator.sendBeacon;
  if (nativeBeacon) {
    navigator.sendBeacon = function (url) {
      if (!isBlocked(url)) return nativeBeacon.apply(navigator, arguments);
      const args = arguments;
      hold(url, () => nativeBeacon.apply(navigator, args));
      return true;
    };
  }

  const imageSource = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  if (imageSource && imageSource.set) {
    Object.defineProperty(HTMLImageElement.prototype, 'src', {
      ...imageSource,
      set(value) {
        if (!isBlocked(value)) { imageSource.set.call(this, value); return; }
        hold(value, () => imageSource.set.call(this, value));
      }
    });
  }

  refresh();
  document.addEventListener('visitorConsentCollected', flush);
  let attempts = 0;
  const poll = setInterval(() => {
    flush();
    attempts += 1;
    if (attempts > 60) clearInterval(poll);
  }, 250);
})();
